import CalculatorWorkspace from './calculators/CalculatorWorkspace';

export default function MarketScanner() {
  return (
    <section id="scanner" className="relative overflow-hidden bg-[#F8FAFC] py-20 md:py-28 px-4 md:px-6">
      {/* Decorative glows */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -right-24 top-16 h-80 w-80 rounded-full bg-violet-100/50 blur-3xl" />
        <div className="absolute -left-20 bottom-0 h-72 w-72 rounded-full bg-violet-100/40 blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-[1180px]">
        <div className="mx-auto max-w-2xl text-center">
          <span className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-violet-600">
            Bộ công cụ giao dịch
          </span>
          <h2 className="mt-3 font-display text-3xl font-bold text-slate-900 md:text-4xl">
            Công cụ tính toán Forex
          </h2>
          <p className="mt-4 text-base leading-relaxed text-slate-600">
            Ba máy tính thiết yếu giúp bạn xác định khối lượng lệnh, ký quỹ và
            lợi nhuận — nhanh chóng, chính xác và hoàn toàn trực quan.
          </p>
        </div>

        <CalculatorWorkspace />

        <p className="mt-6 text-center text-xs text-slate-400">
          * Kết quả chỉ mang tính tham khảo. Tỷ giá, giá trị pip và thông số ký quỹ thực tế có thể thay đổi theo từng sàn giao dịch.
        </p>
      </div>
    </section>
  );
}